import { render, staticRenderFns } from "./filter_source_hoax.vue?vue&type=template&id=2faaeb1d&scoped=true"
import script from "./filter_source_hoax.vue?vue&type=script&lang=js"
export * from "./filter_source_hoax.vue?vue&type=script&lang=js"
import style0 from "./filter_source_hoax.vue?vue&type=style&index=0&id=2faaeb1d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2faaeb1d",
  null
  
)

export default component.exports